import { FC, ReactNode } from 'react';
import { Button } from '@repo/ui/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@repo/ui/components/ui/dialog';

type ConfirmationDialogProps = {
  action?: () => void;
  actionName?: string;
  children: ReactNode;
  description?: string;
  title: string;
  permission: string;
};

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  action,
  actionName,
  children,
  description,
  title,
  permission,
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogPortal>
        <DialogContent className="DialogContent">
          <DialogTitle className="DialogTitle">{title}</DialogTitle>
          <DialogDescription className="DialogDescription">
            {description}
          </DialogDescription>
          <div className="flex mt-25 justify-end">
            <DialogClose asChild>
              <Button
                variant="default"
                data-permission={permission}
                onClick={action}
                data-testid="dialog-confirm-button"
              >
                {actionName}
              </Button>
            </DialogClose>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
